import React from "react";

import { SignIn } from "features/SignIn";

const SignInPage = () => <SignIn />;

export default SignInPage;
